













import { computed, defineComponent, PropType } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { $t } from "@/lib/i18nHelpers";
import { printPaymentPackage } from "@/lib/moneyHelpers";
import config from "@/config";
import { FormFields, FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import WelcomeMessageEditor from "@/components/WelcomeMessageEditor";

export default defineComponent({
  name: "PriceLevelEditForm",
  components: { BaseForm, WelcomeMessageEditor },
  model: {
    prop: "values",
    event: "input",
  },
  props: {
    values: { type: Object as PropType<FormValues>, required: true },
    paymentPackages: { type: Array as PropType<PaymentPackage[]>, required: true },
    priceLevelId: { type: String, default: "" },
  },
  setup(props) {
    const isWelcomeMessageOn = computed(() => {
      return config.featureWelcomeMessage;
    });
    const subscriptionPrices = computed(() => {
      return props.paymentPackages.map(item => ({
        value: item.id,
        text: printPaymentPackage(item),
      }));
    });

    const fields = computed<FormFields>(() => {
      return [
        {
          name: "pricePackageId",
          label: $t("Price per month"),
          type: "select",
          options: subscriptionPrices.value,
          hint: $t("New price for new subscriptions only. Existing subscribers keep previous rate."),
        },
        {
          name: "description",
          placeholder: $t("Caption"),
          type: "textarea",
          style: { height: "137px" },
          hint: $t("Tell what kind of content your fans get buying this subscription level access"),
        },
        ...(config.featureWelcomeMessage
          ? [
              {
                name: "messageEditor",
                placeholder: $t("Welcome message for subscribing"),
                label: $t("Welcome message for subscribing"),
              },
            ]
          : []),
      ];
    });
    return {
      isWelcomeMessageOn,
      fields,
    };
  },
});
